var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Input } from "@mui/joy";
import { useEffect, useMemo, useState } from "react";
import { useGetEmailsQuery } from "@/store/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faTrash } from "@fortawesome/pro-regular-svg-icons";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
/** <b>Composant d'affichage en mode édition d'un champ de type email</b>*/
export default function EmailFieldEdit(_a) {
    var record = _a.record, fieldName = _a.fieldName, onUpdate = _a.onUpdate, moduleName = _a.moduleName, isOnStudio = _a.isOnStudio;
    var validateEmail = function (email) {
        var emailRegex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{3}$");
        return emailRegex.test(email);
    };
    var shouldFetchEmails = !!(record === null || record === void 0 ? void 0 : record.id);
    var listEmails = useGetEmailsQuery({
        recordId: record.id,
        moduleName: moduleName,
    }, {
        skip: !shouldFetchEmails,
    }).data;
    var defaultValue = useMemo(function () {
        var _a;
        if (!record) {
            return;
        }
        return (_a = listEmails === null || listEmails === void 0 ? void 0 : listEmails.data) === null || _a === void 0 ? void 0 : _a.prefillData;
    }, [record, listEmails]);
    var _b = useState([]), emails = _b[0], setEmails = _b[1];
    useEffect(function () {
        if (defaultValue) {
            setEmails(defaultValue);
        }
    }, [defaultValue]);
    var CheckButtonValue = function (_a) {
        var defaultChecked = _a.defaultChecked, type = _a.type, className = _a.className, name = _a.name, index = _a.index, values = _a.values;
        var _b = useState(defaultChecked), checked = _b[0], setChecked = _b[1];
        var handleClick = function () {
            var _a;
            var _b, _c;
            if (type === "radio") {
                var newEmail1 = values.map(function (item, idx) {
                    var _a;
                    return (__assign(__assign({}, item), (_a = {}, _a[name] = idx === index, _a)));
                });
                setEmails(newEmail1);
                onUpdate &&
                    onUpdate(__assign(__assign({}, record), { email_addresses: newEmail1, email1: ((_b = newEmail1.find(function (e) { return e.primary_address; })) === null || _b === void 0 ? void 0 : _b.email_address) ||
                            "" }));
            }
            else {
                var newValue = !checked;
                setChecked(newValue);
                var newEmail1 = __spreadArray([], values, true);
                newEmail1[index] = __assign(__assign({}, newEmail1[index]), (_a = {}, _a[name] = newValue, _a));
                setEmails(newEmail1);
                onUpdate &&
                    onUpdate(__assign(__assign({}, record), { email_addresses: newEmail1, email1: ((_c = newEmail1.find(function (e) { return e.primary_address; })) === null || _c === void 0 ? void 0 : _c.email_address) ||
                            "" }));
            }
        };
        return (_jsx("div", __assign({ onClick: handleClick, style: { cursor: "pointer" } }, { children: _jsx("input", { type: type, name: name, defaultChecked: defaultChecked, className: "".concat(className) }) })));
    };
    var handleChange = function (event, index, values) {
        var _a;
        var _b;
        var _c = event.target, name = _c.name, value = _c.value;
        var newEmail1 = __spreadArray([], values, true);
        newEmail1[index] = __assign(__assign({}, newEmail1[index]), (_a = {}, _a[name] = value, _a));
        setEmails(newEmail1);
        onUpdate &&
            onUpdate(__assign(__assign({}, record), { email_addresses: newEmail1, email1: ((_b = newEmail1.find(function (e) { return e.primary_address; })) === null || _b === void 0 ? void 0 : _b.email_address) || "" }));
    };
    var DeleteEmail = function (_a) {
        var defaultChecked = _a.defaultChecked, index = _a.index, values = _a.values;
        var _b = useState(defaultChecked), checked = _b[0], setChecked = _b[1];
        var handleClick = function () {
            var _a;
            var newValue = !checked;
            setChecked(newValue);
            var newEmail1 = __spreadArray([], values, true);
            newEmail1[index] = __assign(__assign({}, newEmail1[index]), { deleted: newValue });
            if (window.confirm("Êtes-vous sûr de vouloir supprimer cet e-mail ?")) {
                setEmails(newEmail1);
                onUpdate &&
                    onUpdate(__assign(__assign({}, record), { email_addresses: newEmail1, email1: ((_a = newEmail1.find(function (e) { return e.primary_address; })) === null || _a === void 0 ? void 0 : _a.email_address) ||
                            "" }));
            }
        };
        return (_jsx("div", __assign({ onClick: handleClick, style: { cursor: "pointer" } }, { children: _jsx(FontAwesomeIcon, { icon: faTrash, className: "m-1" }) })));
    };
    var uuidv4 = require("uuid").v4;
    var createDefaultEmail = function () {
        var newEmail = {
            email_address: "",
            email_address_caps: "",
            invalid_email: false,
            opt_out: false,
            confirm_opt_in: "",
            date_created: "",
            date_modified: "",
            id: uuidv4(),
            email_address_id: "",
            bean_id: record.id || "",
            bean_module: moduleName || "",
            primary_address: true,
            reply_to_address: false,
            deleted: false,
        };
        return newEmail;
    };
    var addEmails = function (values) {
        var _a;
        var newEmail = createDefaultEmail();
        var updatedEmails = __spreadArray([
            __assign(__assign({}, newEmail), { primary_address: true, invalid_email: false })
        ], values.map(function (e) { return (__assign(__assign({}, e), { primary_address: false })); }), true);
        setEmails(updatedEmails);
        onUpdate &&
            onUpdate(__assign(__assign({}, record), { email_addresses: updatedEmails, email1: ((_a = updatedEmails.find(function (e) { return e.primary_address; })) === null || _a === void 0 ? void 0 : _a.email_address) ||
                    "" }));
    };
    /*const values =
      typeof record["email1"] === "object" ? record["email1"] : emails;*/
    var values = emails;
    return (_jsx("div", __assign({ className: "w-full" }, { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsxs(_Fragment, { children: [_jsx(FontAwesomeIcon, { icon: faPlus, className: "text-[rgb(var(--color-blue-700))] cursor-pointer", onClick: function () { return addEmails(values); } }), _jsx("table", __assign({ className: "flex flex-col items-end mt-1 ml-6 w-full text-[var(--colors-label)]" }, { children: _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ className: "w-8" }, { children: _jsx("span", __assign({ title: "Primary" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" }) })) })) })), _jsx("th", __assign({ className: "w-8" }, { children: _jsx("span", __assign({ title: "Reply to" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" }) })) })) })), _jsx("th", __assign({ className: "w-8" }, { children: _jsx("span", __assign({ title: "Opt-out" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" }) })) })) })), _jsx("th", __assign({ className: "w-8" }, { children: _jsx("span", __assign({ title: "Invalid" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" }) })) })) })), _jsx("th", { className: "w-8" })] }) }) })), values &&
                    (values === null || values === void 0 ? void 0 : values.map(function (item, index) { return (_jsx("div", __assign({ className: "flex my-2 " }, { children: item.deleted ? (_jsxs("div", __assign({ className: "w-full border rounded-md flex " }, { children: [_jsx("span", __assign({ className: "flex items-center pl-2 pr-1" }, { children: _jsx(FontAwesomeIcon, { icon: faAt, className: "text-gray-300" }) })), _jsx("div", __assign({ className: "w-full py-2 pl-2 line-through bg-gray-200 border-none text-sm text-gray-500" }, { children: item.email_address
                                        ? item.email_address
                                        : "email@example.com" }))] }))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "w-full border rounded-md flex" }, { children: [_jsx("span", __assign({ className: "flex items-center pl-2 pr-1" }, { children: _jsx(FontAwesomeIcon, { icon: faAt, className: "text-gray-500" }) })), _jsx(Input, { placeholder: "email@example.com", type: "email", value: item.email_address, name: "email_address", size: "sm", className: "w-full py-2 p-r pl-8 rounded-md", onChange: function (event) { return handleChange(event, index, values); } })] })), _jsx(CheckButtonValue, { defaultChecked: item.primary_address, type: "radio", className: "m-2", name: "primary_address", index: index, values: values }), _jsx(CheckButtonValue, { defaultChecked: item.reply_to_address, type: "radio", className: "m-2", name: "reply_to_address", index: index, values: values }), _jsx(CheckButtonValue, { defaultChecked: item.opt_out, type: "checkbox", className: "m-2", name: "opt_out", index: index, values: values }), _jsx(CheckButtonValue, { defaultChecked: item.invalid_email, type: "checkbox", className: "m-2", name: "invalid_email", index: index, values: values }), _jsx(DeleteEmail, { defaultChecked: item.deleted, index: index, values: values })] })) }), index)); }))] })) })));
}
